import React, { forwardRef, useEffect, useState } from 'react';
import { CloseIconMedium } from '@hm-group/fabric-icons/icons/CloseIcon';
import cn from 'classnames';
import IconButton from "../../Buttons/IconButton";
import HeadingLarge from "../../Typography/headings/HeadingLarge";
import { getScrollbarSize, getBodyPadding } from './handleScrollbar';
import "./Modal.css";
var styles = { "header": "f10030", "header_heading": "bad24f", "content": "ca411a", "actions": "ec6e1b", "closeButton": "ee87dd", "size_small": "c59000", "size_medium": "c08cb8" };
import { BasePanel } from '../BasePanel';
const Modal = forwardRef((props, ref) => {
    const { actions, heading, closeLabel, content, onClose, isOpen, size = 'small', testId, ariaLabelId = 'modal-heading', } = props;
    const [tabIndex, setTabIndex] = useState(-1);
    useEffect(() => {
        if (isOpen) {
            setTabIndex(0);
            document.body.style.paddingInlineEnd = `${getBodyPadding() + getScrollbarSize()}px`;
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        }
        return () => {
            setTabIndex(-1);
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.body.style.paddingInlineEnd = '';
        };
    }, [isOpen]);
    return (React.createElement(BasePanel, Object.assign({}, props, { type: "modal", position: "center", className: cn(styles[`size_${size}`]) }),
        React.createElement("div", { className: styles.header },
            React.createElement(HeadingLarge, { Tag: "h2", isMarginless: true, id: ariaLabelId, className: styles.header_heading }, heading),
            React.createElement(IconButton, { className: styles.closeButton, variant: "ghost", iconElement: React.createElement(CloseIconMedium, null), onClick: onClose, tabIndex: tabIndex }, closeLabel)),
        React.createElement("div", { className: styles.content, "data-testid": testId, ref: ref }, content),
        actions && React.createElement("div", { className: styles.actions }, actions)));
});
export default Modal;
//# sourceMappingURL=Modal.js.map